<template>
  <el-container>
    <el-header style="height: 35px; border-bottom: 1px solid #eee">
      <el-row type="flex" justify="space-between" align="middle">
        <el-popover v-if="record.items.length > 1" placement="bottom-start" trigger="hover" v-model="showRecordSelect">
          <!-- <el-scrollbar style="max-height: 30rem"> -->
          <el-row v-for="(row, index) in record.items" :key="row.id" :class="index ? 'top-pad' : ''" style="min-width: 12rem">
            <el-divider v-if="row.curr" style="margin: 0"><small class="info">当前病历</small></el-divider>
            <el-link v-else @click="switchRecord(row)" :underline="false" :disabled="record.curr && record.curr.id == row.id">
              <el-tag v-if="row.ifArchive" type="danger" hit size="mini">归档</el-tag>
              <el-tag v-else-if="row.continuable" type="success" hit size="mini">连续</el-tag>
              <el-tag v-else-if="row.editingUserName" type="warning" hit size="mini" :title="row.editingUserName">锁定</el-tag>
              <el-tag v-else type="primary" hit size="mini">正常</el-tag>
              {{ row.opTime | fmtDate }} <small>{{ row.deptCode | dictText("Dept") }}</small> {{ row.submitUserName }} <small> {{ row.diagnosis }}</small>
            </el-link>
          </el-row>
          <!-- </el-scrollbar> -->
          <el-link slot="reference" type="primary" :underline="false">
            <span v-if="record.curr">
              {{ record.curr.opTime | fmtDate }} {{ record.curr.submitUserName }} <small>{{ record.curr.diagnosis }}</small>
            </span>
            <span v-else>共有 {{ record.items.length - 1 }} 条既往病历，请选择！</span>
          </el-link>
        </el-popover>
        <span v-if="!loading && record.items.length < 2" class="danger">既往病历不存在</span>
        <el-button v-if="record.curr && record.curr.continuable" type="success" icon="el-icon-connection" plain size="mini" @click="$emit('relate', record.curr)">连续病历</el-button>
        <el-button v-if="record.curr" type="warning" icon="el-icon-document-copy" plain size="mini" @click="apply">引用</el-button>
        <el-popover v-if="record.curr && doc.items.length" placement="bottom-start" trigger="hover" v-model="showDocSelect">
          <el-row v-for="(item, index) in doc.items" :key="item.id" :class="index ? 'top-pad' : ''">
            <el-link :underline="false" @click="switchDoc(item)" :disabled="doc.curr && doc.curr.id == item.id">
              <el-tag v-if="item.isMissing" type="danger" size="mini" hit>缺失</el-tag>
              <i v-else class="el-icon-document" />
              {{ item.tmplCode | dictText("MrTemplate") }}
            </el-link>
          </el-row>
          <el-link type="primary" slot="reference" :underline="false">
            <span v-if="doc.curr">
              <el-tag v-if="doc.curr.isMissing" type="danger" size="mini" hit>缺失</el-tag>
              <i v-else class="el-icon-document" />
              {{ doc.curr.tmplCode | dictText("MrTemplate") }}
            </span>
            <span v-else>共有 {{ doc.items.length }} 份文书，请选择！</span>
          </el-link>
        </el-popover>
        <span v-if="!loading && record.curr && !doc.items.length" class="danger">当前病历不含文书！</span>
      </el-row>
    </el-header>
    <el-main style="position: absolute; top: 35px; bottom: 0px; left: 0; right: 0">
      <Ide ref="ide" readonly />
    </el-main>
  </el-container>
</template>
<script>
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      visible: Boolean,
      main: Object,
    },
    components: {
      Ide: () => import("./_ide.vue"),
    },
    data() {
      return {
        showRecordSelect: false,
        showDocSelect: false,
        loading: false,
        record: {
          items: [],
          curr: null,
        },
        doc: {
          items: [],
          curr: null,
        },
      };
    },
    computed: {
      ...mapGetters(["user"]),
      isIp() {
        return !!this.main?.ipNo;
      },
    },
    watch: {
      main(val) {
        this.page();
      },
    },
    mounted() {
      this.page();
    },
    methods: {
      page() {
        this.record.items = [];
        this.record.curr = null;
        this.closeFile();
        if (!this.main) {
          return;
        }
        this.$api.MrMain.query({
          patientCode: this.main.patientCode,
          // deptCode: this.main.deptCode,
          sort: "id",
          asc: "false",
          pageSize: 10,
          pageIndexOnView: 1,
          notNulls: this.isIp ? "ipNo" : "opNo", // 住院病历查询时，只显示有住院号的病历。门诊也一样。
        }).then((res) => {
          if (res.items.length) {
            let idx = res.items.findIndex((o) => o.id == this.main.id);
            if (idx < 0) {
              return;
            }
            res.items[idx].curr = true;
            let linkable = res.items[idx + 1];
            if (linkable && (!linkable.editingUserCode || linkable.editingUserCode == this.user.code)) {
              linkable.continuable = true;
            }
          }
          this.record.items = res.items;
          if (this.record.items.length > 1) {
            this.switchRecord(this.record.items[0].curr ? this.record.items[1] : this.record.items[0]);
          }
        });
      },
      switchRecord(row) {
        this.closeFile();
        this.showRecordSelect = false;
        this.record.curr = row;
        this.$api.Mr.query({ mainId: row.id }).then((res) => {
          this.doc.items = res.items;
          if (res.items.length) {
            this.switchDoc(res.items[0]);
          }
        });
      },
      switchDoc(item) {
        if (!item || item.isMissing) {
          return;
        }
        this.closeFile();
        this.showDocSelect = false;
        this.doc.curr = item;
        this.$api.MrVer.view(item.id).then((res) => {
          if (!res) {
            this.$set(item, "isMissing", true);
            return;
          }
          if (this.$refs.ide) this.$refs.ide.openFile(res.content, false, res.ifEditing);
        });
      },
      closeFile() {
        if (this.$refs.ide) this.$refs.ide.closeFile();
      },
      apply() {
        let txt = this.$refs.ide.getSelectedText();
        this.$emit("apply", txt);
      }
    },
  };
</script>
<style scoped>
  .el-divider--horizontal {
    margin: 2px 0;
  }
</style>
